/**
 * Loan Cost Calculator
 */
$(document).on("ready", function () {
  $(document).on("click", ".infoIcon", function () {
    addOverlay("infoOverlay", $(this).data("text"));
  });

  if ($("#loan-cost-calculator").length) {
    $("#loan-cost-calculator").on("keyup", ".dlr", function () {
      formatNum(this);
    });
    $("#loan-cost-calculator").on("change", "input", function () {
      calculateLoan();
    });
    $("#loan-cost-calculator").on("focusin", "input", function () {
      if (parseInt($(this).val()) === 0 || $(this).val() === typeof undefined || $(this).val() === "") $(this).val("");
    });
    $("#loan-cost-calculator").on("focusout", "input", function () {
      if (parseInt($(this).val()) === 0 || $(this).val() === typeof undefined || $(this).val() === "") $(this).val(0);
    });
    $("#career").on("change", function () {
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action:'fw_get_salary',
          id: $("#career").val(),
        },
        success: function (data) {
          console.log(data);
          $("#Salary").val("$" + data.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        },
        error: function (data) {
          console.log(data);
        },
      });
    });
    $(".calculate .btn").on("click", function (e) {
      e.preventDefault();
      var salary = parseInt($("#Salary").val().replace(/\D/g, ""));
      var annual = parseInt($("#Annual").val());
      var stress = "AVERAGE";
      console.log(salary + ":" + annual);
      if (salary <= 50000) {
        if (annual < 0.1 * salary) {
          stress = "LOW";
        } else if (annual >= 0.1 * salary && annual < 0.15 * salary) {
          stress = "AVERAGE";
        } else {
          stress = "HIGH";
        }
      } else if (salary > 50000) {
        if (annual < 0.15 * salary) {
          stress = "LOW";
        } else if (annual >= 0.15 * salary && annual < 0.25 * salary) {
          stress = "AVERAGE";
        } else {
          stress = "HIGH";
        }
      }
      var intro = "Based on your monthly loan payment of: <span>" + $("#monthly").text() + "</span>, and a projected salary of: <span>" + $("#Salary").val() + "</span> we estimate that your level of financial obligation would be: " + stress;
      $(".intro").html(intro);
      $("#stress-level").attr("src", $("#stress-level").attr("data-src") + stress + ".jpg");
      $('#graphic').removeClass('hidden');
    });
    $(document).on("click", ".setGap", function (e) {
      e.preventDefault();
      $("#LoanAmount").val(parseInt($(this).data("gap")));
      $("#loan-cost-calculator input").change().trigger("change");
      formatNum(document.getElementById("LoanAmount"));
      $(".infoOverlay").remove();
    });
    $(document).on("click", ".setCareer", function (e) {
      e.preventDefault();
      $("#career").val($(this).data("career")).change();
      $(".infoOverlay").remove();
    });
  }
});
